<script lang="ts">
  import { signed_in_user } from '../Users/observables'
  import OrganizationForm from './Form.svelte'
</script>

<div id="container">
  <p>Welcome to the TSF Retro App, {$signed_in_user.displayName}!</p>

  <p>If you are trying to join an ongoing session, contact the organizer for the join link.</p>

  <p>
    If you would like to trial the TSF Retro App with your team for a month (£5 per month thereafter), enter a
    name for your team below.
  </p>

  <p>
    We will then redirect you to our payments provider Stripe, where you will need to enter the details of
    your payment card.
  </p>

  <OrganizationForm />

  <small id="terms-text">
    By Signing up, you are agreeing to our <a
      href="https://www.iubenda.com/terms-and-conditions/93923874"
      target="_blank">Terms</a
    >
    and
    <a href="https://thestartupfactory.tech/privacy-policy/" target="_blank">Privacy Policy</a>
  </small>
</div>

<style>
  #container {
    max-width: 50em;
    display: flex;
    height: 100%;
    flex-flow: column nowrap;
  }

  #terms-text {
    margin-top: 6em;
  }
</style>
